import React, { useState, useEffect } from "react";

import { GetRestaurantsByDate } from "./../../api/approved_chk";
import { GetAcativeRestaurants } from "./../../api/restaurant";
import { GetActiveUsers } from "./../../api/users";

const ApproveCHK = ({ token }) => {
  const [date, setDate] = useState();
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [restaurants, setRestaurants] = useState([]);

  const loading = async () => {
    try {
      const users = await GetActiveUsers(token);
      let us = {};
      for (let u of users) {
        us[u.id] = u;
      }
      setUsers(us);
      const restsaurants = await GetAcativeRestaurants(token);
      let rests = {};
      for (let r of restsaurants) {
        rests[r.id] = r;
      }
      setRestaurants(rests);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loading();
  }, [token]);

  async function donwloadRepost() {
    const response = await GetRestaurantsByDate(token, date);
    console.log(response);
    setData(response);
  }

  function renderBody(row) {
    const renderStatusCircle = (status) => {
      const getColor = () => {
        switch (status) {
          case 1:
            return "#ff4444"; // красный
          case 2:
            return "yellow"; // желтый
          case 3:
            return "#44ff44"; // зеленый
          default:
            return "transparent"; // прозрачный для null/undefined
        }
      };

      return (
        <div
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: getColor(),
            border: status ? "none" : "1px dashed #ccc",
            marginRight: "5px",
          }}
        />
      );
    };
    let directorName = "";
    let TYName = "";
    let HRName = "";
    if (row.HR_status) {
      HRName = `${users[row.HR_id].surname} ${users[row.HR_id].name}`;
    }
    if (row.TY_status) {
      TYName = `${users[row.TY_id].surname} ${users[row.TY_id].name}`;
    }
    if (row.director_status) {
      directorName = `${users[row.director_id].surname} ${
        users[row.director_id].name
      }`;
    }
    return (
      <tr key={row.id}>
        <td>{restaurants[row.restaurant_id].name}</td>
        <td>
          {" "}
          <div className="d-flex align-items-center justify-content-center gap-2">
            {renderStatusCircle(row.director_status)} {directorName}
          </div>
        </td>
        <td>
          {" "}
          <div className="d-flex align-items-center justify-content-center gap-2">
            {renderStatusCircle(row.TY_status)} {TYName}
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center justify-content-center gap-2">
            {renderStatusCircle(row.HR_status)} {HRName}
          </div>
          {/* <hr />
                <div className='text-center'>{row.HR_comment}</div> */}
        </td>
      </tr>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по соласованию ЧК расписания</h1>
        </div>
        <div className="col-md-4" style={{ marginTop: "3%" }}>
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) => setDate(e.target.value)}
            value={date}
          />
        </div>
        <div className="col-md-4" style={{ marginTop: "3%" }}>
          <button className="btn" onClick={donwloadRepost}>
            Выгрузить
          </button>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">Ресторан</th>
              <th scope="col">Согласование директором</th>
              <th scope="col">Согласование ТУ</th>
              <th scope="col">Согласование HR</th>
            </tr>
          </thead>
          <tbody>{data.map((row) => renderBody(row))}</tbody>
        </table>
      </div>
    </div>
  );
};

export default ApproveCHK;
